<td class="pia-listsBlock-item">
  <div class="pia-listsBlock-item-actions">
    <a [routerLink]="['/preview', archivedPia.id]" class="btn pia-tooltip">
      <fa-icon [icon]="faEye"></fa-icon>
      <span
        title="{{ 'homepage.lists.item.tools.consult' | translate }}"
        class="pia-tooltip-text"
        >{{ "homepage.lists.item.tools.consult" | translate }}</span
      >
    </a>
    <a
      href="javascript:;"
      (click)="unarchive(archivedPia.id)"
      class="btn pia-tooltip"
    >
      <fa-icon [icon]="faRefresh"></fa-icon>
      <span
        title="{{ 'homepage.lists.item.tools.unarchive' | translate }}"
        class="pia-tooltip-text"
        >{{ "homepage.lists.item.tools.unarchive" | translate }}</span
      >
    </a>
    <a
      href="javascript:;"
      (click)="remove(archivedPia.id)"
      class="btn pia-tooltip"
    >
      <fa-icon [icon]="faTrash"></fa-icon>
      <span
        title="{{ 'homepage.lists.item.tools.remove' | translate }}"
        class="pia-tooltip-text"
        >{{ "homepage.lists.item.tools.remove" | translate }}</span
      >
    </a>
  </div>
</td>
<td class="pia-listsBlock-item pia-listsBlock-item-title">
  <div>{{ archivedPia.name }}</div>
  @if (attachments && attachments.length > 0) {
  <div class="pia-listsBlock-item-attachment" aria-hidden="true">
    <span class="pia-icons pia-icon-attachment"></span>
    <ul>
      @for (attachment of attachments; track attachment) {
      <li>{{ attachment.name }}</li>
      }
    </ul>
  </div>
  }
</td>
<td class="pia-listsBlock-item">
  @if ( archivedPia.updated_at && archivedPia.updated_at.toString() !== 'Invalid
  Date' ) {
  <time>{{
    archivedPia.updated_at
      | date: "shortDate":"":languagesService.selectedLanguage
  }}</time>
  }
</td>
<td class="pia-listsBlock-item">
  <div>{{ archivedPia.author_name }}</div>
</td>
<td class="pia-listsBlock-item">
  <div>{{ archivedPia.evaluator_name }}</div>
</td>
<td class="pia-listsBlock-item">
  <div>{{ archivedPia.validator_name }}</div>
</td>
<td class="pia-listsBlock-item">
  @if (archivedPia.structure_id) {
  <div>{{ archivedPia.structure_name }}</div>
  }
</td>
<td class="pia-listsBlock-item progress">
  <div class="pia-cardsBlock-item-status-progressBar">
    <span title="{{ piaService.getStatusName(archivedPia) | translate }}">{{
      piaService.getStatusName(archivedPia) | translate
    }}</span>
    <progress max="100" value="{{ archivedPia.progress }}"></progress>
  </div>
</td>
